/**
 * How to Use:
 * - Ensure each input element you want to track has both "form-id" and "product_id" attributes.
 * - Make sure there is a form element with an "id" attribute that matches the "form-id" value.
 * - The corresponding form should contain an input with name="id" to receive the variant ID.
 * 
 * Example:
 *  <form id="form1">
 *      <input type="hidden" name="id">
 *      <input type="checkbox" form-id="form1" product_id="123" value="Red">
 *      <input type="checkbox" form-id="form1" product_id="123" value="Small">
 *  </form>
 */

document.querySelectorAll("input[form-id]").forEach((elem)=>{
    elem.addEventListener("change", async (event)=>{

        let form_id = event.currentTarget.getAttribute("form-id") || null
        if(!form_id) return

        let productId = event.currentTarget.getAttribute("product_id") || null
        if(!productId)return

        let selectedOptions = [];
        document.querySelectorAll(`input[form-id="${form_id}"]`).forEach((option) => {
            if (!selectedOptions.includes(option.value) && option.checked) {
                selectedOptions.push(option.value);
            }
        });

        let get_form = document.getElementById(form_id) || null
        if(!get_form) return

        try {
            let response = await fetch(`/products/${productId}.json`);
            if (response.ok) {
                let data = await response.json();
                const variants = data.product.variants;

                variants.forEach((variant)=>{
                    let options = []
                    if(variant.option1){
                        options.push(variant.option1)
                    }
                    if(variant.option2){
                        options.push(variant.option2)
                    }
                    if(variant.option3){
                        options.push(variant.option3)
                    }

                    let arraysContainSameElements = () => {
                        if (options.length !== selectedOptions.length) {
                            return false;
                        }
                        
                        const sortedArr1 = [...options].sort();
                        const sortedArr2 = [...selectedOptions].sort();
                        
                        return sortedArr1.every((value, index) => value === sortedArr2[index]);
                    };

                    if(arraysContainSameElements()){
                        let v_id = get_form.querySelector(`input[name="id"]`) || null
                        if(!v_id || !variant.id) return
                        v_id.value = variant.id

                        const event = new CustomEvent('change', {
                            bubbles: true,
                            cancelable: true,
                            detail: {
                                current_variant: variant
                            }
                        });
                        v_id.dispatchEvent(event);

                        const url = new URL(window.location.href);
                        url.searchParams.set("variant", variant.id);
                        window.history.pushState({}, '', url);
                        
                    }
                })

            } else {
              console.log("Response not okay, status:", response.status);
            }

        } catch (error) {
            console.log("Variant picker error: ", error);
        }
          
    })
})


document.querySelectorAll(`input[name="id"]`).forEach((elem)=>{
    elem.addEventListener("change", (event)=>{
        let variant = event?.detail?.current_variant
        if(!variant)return

        console.log(variant)
    })
})


// add to cart 
document.querySelectorAll(`form[action="/cart/add"]`).forEach((elem)=>{
    elem.addEventListener("submit", (event)=>{
        // event.preventDefault()
        let form = event.currentTarget
        if(!form)return

        let formData = new FormData(form);
        let serializedData = new URLSearchParams(formData).toString();

        console.log(serializedData)

    })
})